
export const Analytics = {
    record: ({ name, attributes }) => {
        console.log(name, attributes)
    }
}